export const state = {
  buissness: [],
  networks: [],
  isLoading: false
}